import type { Environment } from '../../environment';
import type {
  EntityObject, OverreactRequestShape,
} from '../../public-types';
import { createDataNode, getDataNode } from '../../store';
import type { ResponseContract } from '../response-contract';

export default function handler<
  TVariables extends object,
  TData,
  TEntity extends EntityObject,
  TResult extends TEntity | TEntity[] | null,
>(
  environment: Environment,
  request: OverreactRequestShape<TVariables, TData, TResult, TEntity>,
  error: unknown,
) {
  return (context: ResponseContract<TVariables, TData, TEntity, unknown, TResult>) => {
    const { store } = environment;
    const dataNode = getDataNode(context.schemaNode) || createDataNode(context.schemaNode, store);
    dataNode.getDataRef(request.id).onError(error, request);
    request.errorCb?.(error, request);
  };
}
